import { useEffect } from 'react'

const METRIKA_ID = Number(import.meta.env.VITE_YANDEX_METRIKA_ID || 107061705)
const SCRIPT_SRC = 'https://mc.yandex.ru/metrika/tag.js'
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll']

export default function YandexMetrika() {
  useEffect(() => {
    if (typeof window === 'undefined' || !METRIKA_ID) {
      return undefined
    }

    // Очередь ym() создаётся сразу — вызовы до загрузки скрипта не теряются
    if (!window.ym) {
      window.ym = function (...args) {
        ;(window.ym.a = window.ym.a || []).push(args)
      }
      window.ym.l = Date.now()
    }

    if (!window.__yandexMetrikaInitialized) {
      window.ym(METRIKA_ID, 'init', {
        accurateTrackBounce: true,
        clickmap: true,
        trackLinks: true,
        webvisor: true,
      })
      window.__yandexMetrikaInitialized = true
    }

    // Сам счётчик — 93 КБ JS. Грузим его после отрисовки контента:
    // в простое браузера или при первом действии пользователя, что наступит раньше.
    let done = false
    const loadScript = () => {
      if (done) return
      done = true
      cleanup()
      if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return
      const script = document.createElement('script')
      script.async = true
      script.src = SCRIPT_SRC
      document.head.appendChild(script)
    }

    const cleanup = () => {
      INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, loadScript))
    }

    INTERACTION_EVENTS.forEach((event) =>
      window.addEventListener(event, loadScript, { once: true, passive: true })
    )

    const schedule = () => {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(loadScript, { timeout: 4000 })
      } else {
        window.setTimeout(loadScript, 2500)
      }
    }

    if (document.readyState === 'complete') {
      schedule()
    } else {
      window.addEventListener('load', schedule, { once: true })
    }

    return cleanup
  }, [])

  return null
}
